import { Component, Output, EventEmitter, ViewChild } from "@angular/core";
import { DxDateBoxComponent } from "devextreme-angular";
import { NotificationService } from "../../common/component/notification/notification.service";
import { O2AwardsReportFilterCriteria } from "./o2-portal-awards-by-region/O2AwardsReportFilterCriteria";
import { O2ReportFilters } from "./o2-report-filters.service";

@Component({
    selector: 'o2-report-filters',
    templateUrl: './o2-report-filters.component.html',
    styleUrls: ['./o2-report-filters.component.scss']
})

export class O2ReportFiltersComponent {

    isLoadPanelVisible: boolean = false;
    regions: any;
    fromDate: any;
    toDate: any;
    selectedRegions: any;
    o2PortalAwardsData: any;

    @Output() viewReport = new EventEmitter<any>();

    @ViewChild("fromDateBox", { static: false }) dxFromDate: DxDateBoxComponent;
    @ViewChild("toDateBox", { static: false }) dxToDate: DxDateBoxComponent;

    constructor(private notificationService: NotificationService, private o2ReportFilters: O2ReportFilters) {

        this.fromDate = new Date();
        this.fromDate.setFullYear(this.fromDate.getFullYear() - 5);

        this.toDate = new Date();
        this.toDate.setFullYear(this.toDate.getFullYear() - 1);

        this.validateFromDate = this.validateFromDate.bind(this);
        this.validateToDate = this.validateToDate.bind(this);

        this.getRegions();
    }

    getRegions() {
        this.isLoadPanelVisible = true;
        this.o2ReportFilters.getRegions().subscribe({
            next: regions => {
                this.regions = regions;
                this.selectedRegions = regions;
                this.isLoadPanelVisible = false;
                this.getReports();
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching Regions", error);
            }
        });
    }

    getReports() {
        if (this.selectedRegions && this.selectedRegions.length > 0 && this.dxFromDate.isValid && this.dxToDate.isValid) {

            this.isLoadPanelVisible = true;
            this.o2ReportFilters.getO2PortalAwardsData(new O2AwardsReportFilterCriteria(this.fromDate.getFullYear(), this.toDate.getFullYear(), this.selectedRegions)).subscribe({
                next: o2PortalAwardsData => {
                    this.viewReport.emit(o2PortalAwardsData);
                    this.isLoadPanelVisible = false;
                }, error: (error: any) => {
                    this.isLoadPanelVisible = false;
                    this.notificationService.alert("error", "Error while fetching O2PortalAwards data", error);
                }
            });


        }
    }

    validateFromDate(e) {
        if (this.fromDate && this.toDate && this.fromDate.getFullYear() > this.toDate.getFullYear())
            return false;

        if (this.fromDate && this.toDate && this.fromDate.getFullYear() <= this.toDate.getFullYear()) {
            this.dxToDate.validationStatus = 'valid'
        }

        return true;
    }

    validateToDate(e) {
        if (this.fromDate && this.toDate && this.fromDate.getFullYear() > this.toDate.getFullYear())
            return false;

        if (this.fromDate && this.toDate && this.fromDate.getFullYear() <= this.toDate.getFullYear()) {
            this.dxFromDate.validationStatus = 'valid'
        }

        return true;
    }
}
